import React from 'react'
import { useField } from 'formik'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'
import { useTranslation } from 'react-i18next'
import { FormControlLabel } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import styles from './CheckboxField.module.css'

export function CheckboxField ({ name, label, disabled, onChange }) {
  const { t } = useTranslation()
  const [, meta, helpers] = useField(name)
  const { value } = meta
  const { setValue } = helpers

  const handleChange = event => {
    setValue(event.target.checked)
    onChange && onChange()
  }

  return (
    <FormControlLabel
      control={<PrimaryCheckbox checked={value} disabled={disabled} onChange={handleChange}/>}
      label={<Typography className={styles.label}>{t(label)}</Typography>}/>
  )
}
